import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Loader from "../../../Loader";
import { T } from '../../../../utils/I18n/I18n';
import AddressPresentation from "../../PersonalAreaAddress/ShowAddress/AddressPresentation";
import { useQuery } from "@apollo/react-hooks";
import { GET_ORDERBOOK } from "../orderbookQuery";
import useResponsive from "../../../../hooks/useResponsive";
import { useCartContext } from "../../../../context/CartContext";
import Prices from '../../../BaseCurrencyPrices/Prices';

const Invoice = () => {
    const { loading, error, data, refetch } = useQuery(GET_ORDERBOOK);
    const navigate = useNavigate(); // Poprawiono nazwę zmiennej z 'history' na 'navigate'
    const params = useParams();
    const { isMobile } = useResponsive();
    const [items, setItems] = useState([]);
    const [cur, setCur] = useState("");
    const [currency, setCurrency] = useState("");
    const { handleProductAdd } = useCartContext();

    // Pierwszy useEffect - zawsze wywoływany
    useEffect(() => {
        if (!error && !loading && data) {
            const order = data.customerOrderbook.orders.items.find(({ id }) => id === params.ordersDetailsId);
            setItems(order || []);
            setCur(data.customerOrderbook.orders.items[0]?.total.grand_total.currency || "");
            refetch();
        }
    }, [data, error, loading, refetch, params.ordersDetailsId]);

    // Drugi useEffect - zawsze wywoływany
    useEffect(() => {
        if (cur && cur.length > 0) {
            setCurrency(cur === "HRK" ? "kn" : cur);
        }
    }, [cur]);

    const addProductsToCart = () => {
        if (items.items) {
            items.items.forEach(({ product_sku, quantity_ordered }) => {
                handleProductAdd(product_sku, quantity_ordered);
            });
            navigate("/checkout/cart");
        }
    };

    if (error) {
        return <h1>{error.message}</h1>;
    }

    return (
        <div className="orders-details">
            {loading && <Loader />}
            {!loading && !data && <h3>Podaci se nisu učitali, probajte ponovno</h3>}

            {items.number && (
                <div className="orders-details__content">
                    <h1>
                        <T id="personalArea.oneOrder" /> # {items.number}
                    </h1>
                    <h3>
                        <T id="orders.orderStatus" /> {items.status}
                    </h3>
                    <div className="orders-details__content__header-text">
                        <p>
                            <T id="orders.orderDate" />: {items.order_date}
                        </p>
                        <p onClick={addProductsToCart}>
                            <a href="#">
                                <T id="orders.repeatOrder" />
                            </a>
                        </p>
                        <p>
                            <a href="#" onClick={() => window && window.print()}>
                                <T id="orders.printOrder" />
                            </a>
                        </p>
                        <p>
                            <Link to={`/customer/account/orders/${params.ordersDetailsId}`}>
                                <T id="orders.orderedProducts" />
                            </Link>
                        </p>
                        <p className="isBold">
                            <T id="personalArea.receipt" />
                        </p>
                        {items.credit_memos?.[0] && (
                            <p>
                                <Link to={`/customer/account/orders/creditmemo/${params.ordersDetailsId}`}>
                                    <T id="orders.refund" />
                                </Link>
                            </p>
                        )}
                        {items.shipments?.[0] && (
                            <p>
                                <Link to={`/customer/account/orders/shipment/${params.ordersDetailsId}`}>
                                    <T id="orders.shipment" />
                                </Link>
                            </p>
                        )}
                    </div>

                    <div className="orders-details__content__table">
                        <table>
                            {!isMobile && (
                                <thead>
                                <tr>
                                    <th><T id="orders.productName" /></th>
                                    <th><T id="product.code" /></th>
                                    <th><T id="cart.price" /></th>
                                    <th>
                                        <T id="orders.included" /> <T id="cart.quantity" />
                                    </th>
                                    <th><T id="cart.total" /></th>
                                </tr>
                                </thead>
                            )}

                            {items.invoices?.[0]?.items &&
                                items.invoices[0].items.map(({ product_name, product_sku, product_sale_price, quantity_invoiced }) => (
                                    <tbody key={product_sku}>
                                    <tr>
                                        <td className="orders-details__content__table__product-name">
                                            {isMobile && <span className="margin-span"><T id="orders.productName" />:</span>}
                                            {product_name}
                                        </td>
                                        <td>
                                            {isMobile && <span className="margin-span"><T id="product.code" />:</span>}
                                            {product_sku}
                                        </td>
                                        <td>
                                            {isMobile && <span className="margin-span"><T id="cart.price" />:</span>}
                                            <span className="pink">
                                                    <Prices amount={product_sale_price.value} isMinicart breakRow />
                                                </span>
                                        </td>
                                        <td>
                                            <p>
                                                {isMobile && <span className="margin-span"><T id="cart.quantity" />:</span>}
                                                {quantity_invoiced}
                                            </p>
                                        </td>
                                        <td>
                                            {isMobile && <span className="margin-span"><T id="cart.total" />:</span>}
                                            <span className="pink">
                                                    <Prices amount={product_sale_price.value * quantity_invoiced} isMinicart breakRow />
                                                </span>
                                        </td>
                                    </tr>
                                    </tbody>
                                ))}

                            {items.invoices?.[0]?.total && (
                                <tfoot>
                                <tr>
                                    <th colSpan="4"><T id="cart.total" /></th>
                                    <td><Prices amount={items.invoices[0].total.subtotal.value} isMinicart breakRow /></td>
                                </tr>
                                {items.total.discounts.length !== 0 && (
                                    <tr>
                                        <th colSpan="4"><T id="orders.discount" /></th>
                                        <td>-<Prices amount={items.total.discounts[0].amount.value} isMinicart breakRow /></td>
                                    </tr>
                                )}
                                <tr>
                                    <th colSpan="4"><T id="cartSummary.shipping" /></th>
                                    <td>
                                        <Prices
                                            amount={items.invoices[0].total.shipping_handling.amount_including_tax.value}
                                            isMinicart
                                            breakRow
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th colSpan="4"><T id="giftWrap.wrapping" /></th>
                                    <td>
                                        <Prices
                                            amount={items.gift_wrapping === null ? 0 : items.gift_wrapping.price.value}
                                            isMinicart
                                            breakRow
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th colSpan="4"><T id="cartSummary.taxes" /></th>
                                    <td>
                                        <Prices
                                            amount={items.invoices[0].total.taxes[0].amount.value}
                                            isMinicart
                                            breakRow
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th colSpan="4"><T id="cartSummary.totalFinal" /></th>
                                    <td className="orders-details__content__table__grand-total">
                                        <Prices
                                            amount={items.invoices[0].total.grand_total.value}
                                            isMinicart
                                            breakRow
                                        />
                                    </td>
                                </tr>
                                </tfoot>
                            )}
                        </table>

                        <div className="orders-details__content__go-back-btn">
                            <Link to="/customer/account/orders"><T id="orders.goBack" /></Link>
                        </div>

                        {items.shipping_address && (
                            <div className="orders-details__content__addresses">
                                <h2><T id="orders.orderInfo" /></h2>
                                <div className="orders-details__content__addresses-shipping">
                                    <div className="orders-details__content__addresses-shipping-address">
                                        {items.shipping_address ? (
                                            <AddressPresentation address={items.shipping_address} isOrdersbook />
                                        ) : (
                                            <p className="address__no-info"><T id="address.noInfo" /></p>
                                        )}
                                    </div>
                                </div>
                                <div className="orders-details__content__addresses-shipping">
                                    <div className="orders-details__content__addresses-shipping-address">
                                        {items.billing_address ? (
                                            <AddressPresentation address={items.billing_address} addressType="naplatu" isOrdersbook />
                                        ) : (
                                            <p className="address__no-info"><T id="address.noInfo" /></p>
                                        )}
                                    </div>
                                    <div className="orders-details__content__addresses-shipping-delivery">
                                        <p><strong><T id="orders.paymentMethod" /></strong></p>
                                        <p>{items.payment_methods[0].name}</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Invoice;